

import { IRestfulConfigMap } from "@core/data-access/restful";
import { envConfig } from "@env/env-config";


let PartnerCartRestServiceConfig: IRestfulConfigMap = {
    "partnerCartRestService": {
        // TODO base对应接口地址
        appPath: envConfig.appPath("base"),
        isAuth: true,
        actions: {
            // 获取购物车数据
            get: {
                method: "get",
                path: "api/partner/shoppingCart",
                testPath: "api/partner/shoppingCart",
                needCurrency: true
            },
            // 更新购物车项
            updateItem: {
                method: "put",
                path: "api/partner/shoppingCart/items/:shoppingCartItemId/v2",
                testPath: "api/partner/shoppingCart/items/:shoppingCartItemId/v2",
                paramDefaults: {
                    shoppingCartItemId: "@shoppingCartItemId"
                },
                needCurrency: true
            },
            // 批量删除
            multiDelete: {
                method: "delete",
                path: "api/partner/shoppingCart/items",
                testPath: "api/partner/shoppingCart/items"
            },
            // 获取购物车项列表
            getItemList: {
                method: "get",
                path: "api/partner/shoppingCart/items",
                testPath: "api/partner/shoppingCart/items",
            },
            // 添加购物车项
            addToCart: {
                method: "post",
                path: "api/partner/shoppingCart/items",
                testPath: "api/partner/shoppingCart/items",

            },
            // 计算勾选项的结算价格
            totalPrice: {
                method: "get",
                path: "api/partner/shoppingCart/items/totalPrice",
                testPath: "api/partner/shoppingCart/items/totalPrice",
                paramDefaults: { itemIds: "@itemIds" }
            },
            // 获取购物车项数量
            totalQty: {
                method: "get",
                path: "api/partner/shoppingCart/items/totalQty",
                testPath: "api/partner/shoppingCart/items/totalQty"
            },
            // 移除购物车项
            deleteCartItem: {
                method: "delete",
                path: "api/partner/shoppingCart/items/:shoppingCartItemId",
                testPath: "api/partner/shoppingCart/items/:shoppingCartItemId",
                paramDefaults: { shoppingCartItemId: "@shoppingCartItemId" },

            },
            // 根据id获取指定购物车项
            getItem: {
                method: "get",
                path: "api/partner/shoppingCart/items/:shoppingCartItemId",
                testPath: "api/partner/shoppingCart/items/:shoppingCartItemId",
                paramDefaults: { shoppingCartItemId: "@shoppingCartItemId" }
            },
            // 合并购物车
            mergeCart: {
                method: "post",
                path: "api/partner/shoppingCart/merger",
                testPath: "api/partner/shoppingCart/merger",
                paramDefaults: { anonymousUserId: "@anonymousUserId" }
            },

            // 批量获取购物车项
            getSpecificMultiItems: {
                method: "get",
                path: "api/user/shoppingCart/items",
                testPath: "api/user/shoppingCart/items",
                paramDefaults: { itemIds: "@itemIds" }
            },
            // 生成预拼单项
            cartPreBulkOrder: {
                method: "post",
                path: "api/partner/shoppingCart/preBulkOrderItems",
                testPath: "api/partner/shoppingCart/preBulkOrderItems",
            },
            // 检查购物车项结算状态
            checkShoppingLineItemsSettledStatus: {
                method: "post",
                path: "api/partner/shoppingCart/items/checkIsSettled",
            },
            // 购物车项结算优惠查询
            getBillingOffers: {
                method: "post",
                path: "api/partner/shoppingCart/items/discountInfo",
                needCurrency: true
            }
        }
    }
}

export { PartnerCartRestServiceConfig };